<!--身份、城市选择-->
<template>
    <div class="home">
        <div class="home_title flex">
            <div class="logo"></div>
        </div>
        <div class="home_container flex">
            <div class="identity_message">
<!--                身份选择-->
                <div class="choice identity_choice">
                    <div class="choice_title">
                        请选择你当前的身份
                    </div>
                    <div class="choice_tips">
                        你可以在求职设置中修改你的求职偏好
                    </div>

                    <div class="gender-box">
                        <div class="gender-btn male-btn"  :class="{'active':  nowGender === 'male'}" @click="setGender('male')">
                            <i class="iconfont iconnan"></i>
                            <span>男生</span>
                        </div>
                        <div class="gender-btn female-btn" :class="{'active':  nowGender === 'female'}" @click="setGender('female')">
                            <span>女生</span>
                            <i class="iconfont iconnv"></i>
                        </div>
                    </div>

                    <div class="flex identity_body">
                        <div class="student">
                            <img class="imgs" :src="`https://files.wondercv.com/pc-intention/${nowGender}-student.png`" alt="" @click="choice('student')">
                            <div class="status">学生党</div>
                        </div>
                        <div class="worker">
                            <img class="imgs" :src="`https://files.wondercv.com/pc-intention/${nowGender}-already_work.png`" alt="" @click="choice('already_work')">
                            <div class="status">职场人</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '~/api'
    // import cityGroup from '@/assets/js/cities'
    import { routerTo, get_tUser } from '@/assets/js/util';
    import {Loading} from "element-ui";
    export default {
        name: "index",
        data(){
            return{
                _c_t:'',
                nowGender: 'male'
            }
        },
        updated(){
          console.log('gengxin');
        },
        mounted() {
            // console.log(window.location.origin,"======>")
        },
        watch:{

        },
        methods:{
            // 设置性别
            setGender (val) {
                this.nowGender = val
            },
            // 选择身份
            choice(status){
                this._c_t = get_tUser().c_t;
                let params = {
                  gender: this.nowGender === 'male' ? '男' : '女'
                }
                api.me.updateUserInfo(this._c_t, params).then(res => {
                  if(res.code === 1000) {
                    routerTo(`/jobs/graduation?identify=${status}`)
                    // this.$router.push({path: '/jobs/graduation', query: {identify: status}})
                  } else {
                    this.$message({ 
                      type:'warning',
                      message:res.message
                    })
                  }
                }).catch(e => {
                  console.log(e);
                })
            }
        }
    }
</script>

<style lang="scss">
    html,body,#app{
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }

    .works{
        width: 224px;
        height: 100%;
        margin-left: 15px;
        overflow: hidden;
        .el-input{
            .el-input__inner{
                line-height: 39px;
                border: none !important;
            }
        }
    }
    .el-scrollbar__wrap{
        overflow-x: hidden!important;
    }
    .group_container{
        .el-scrollbar{
            .el-scrollbar__wrap{
                .el-scrollbar__view{
                    width: 100%;
                    height: 100%;
                    display: flex!important;
                    flex-wrap: wrap;
                    /*margin-left: 10px!important;*/
                    /*justify-content: space-around!important;*/
                    align-content: flex-start!important;
                }
            }
            .el-scrollbar__bar.is-vertical>div{
                width: 0!important;
            }
        }
    }
    .group_title_container{
        .el-scrollbar{
            .el-scrollbar__wrap{
                .el-scrollbar__view{
                    width: 100%;
                    height: 100%;
                    display: flex!important;
                    flex-wrap: wrap;
                    /*margin-left: 10px!important;*/
                    /*justify-content: space-around!important;*/
                    align-content: flex-start!important;
                }
            }
            .el-scrollbar__bar.is-vertical>div{
                width: 0!important;
            }
        }
    }
    .work_group{
        .el-scrollbar{
            .el-scrollbar__wrap{
                .el-scrollbar__view{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-content: flex-start;
                    .work_name{
                        width: auto;
                        height: 32px;
                        line-height: 32px;
                        margin-top: 10px;
                        padding: 0 19px;
                        border-radius:2px;
                        border:1px solid #ececec;
                        color: #9c9c9c;
                        cursor: pointer;
                    }
                    .active{
                        border-color: #FF6644;
                        color: #FF6644;
                    }
                }
            }
        }
    }
</style>

<style lang="scss" scoped>

    .imgs{
        width: 88px;
        height: 88px;
        border-radius: 50%;
        cursor: pointer;
    }
    .status{
        width: 88px;
        height: auto;
        margin-top: 16px;
        color: #404040;
        font-size: 16px;
        text-align: center;
    }
    .home{
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        .home_title{
            width: 100%;
            height: 76px;
            display: none;
            background-color: #fff;
            /*box-shadow:0px 8px 11px 0px rgba(0,0,0,0.08);*/
            /*box-shadow:10px 5px 5px black;*/
            align-items: center;
            .logo{
                width: 164px;
                height: 51px;
                background: url("../../static/images/LOGO@2x.png") no-repeat;
                background-size: 100% 100%;
                margin-left: 8%;
            }
        }
        .home_container{
            width: 100%;
            //height: calc(100% - 76px);
            height: 100%;
            background-color: #F5F5F7;
            justify-content: center;
            //align-items: center;
            //box-shadow:inset 0px 8px 11px 0px rgba(0,0,0,0.08);
            .identity_message{
                width: 528px;
                height: 564px;
                margin-top: 118px;
                //box-shadow:0px 2px 30px 0px rgba(0,0,0,0.13);
                border-radius: 8px;
                background-color: #fff;
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                padding: 64px 56px;
                .choice{
                    width: 100%;
                    height: 100%;
                    text-align: center;
                    .choice_title{
                        font-size: 26px;
                        font-weight:500;
                        color:rgba(64,64,64,1);
                        line-height:30px;
                    }
                    .choice_tips{
                        margin-top: 16px;
                        font-size:14px;
                        font-weight:400;
                        color:#9c9c9c;
                        line-height:14px;
                    }
                    .identity_body{
                        margin-top: 64px;
                        justify-content: space-around;
                    }
                    .city_work{
                        width: 416px;
                        height: 40px;
                        margin-top: 48px;
                        border-radius:2px;
                        align-items: center;
                        border:1px solid #ececec;
                        cursor: pointer;
                        padding: 0 16px 0 0;
                        box-sizing: border-box;
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        .cities{
                            width: 92px;
                            height: 100%;
                            position: relative;
                            justify-content: center;
                            align-items: center;
                            span{
                                color: #606060;
                                font-size: 14px;
                            }
                            .arrows{
                                width: 14px;
                                height: 14px;
                                background: url("../../assets/image/arrows.png") no-repeat;
                                background-size: 100% 100%;
                            }
                        }
                        .cities:after{
                            content: '';
                            width: 0;
                            height: 21px;
                            position: absolute;
                            right: 0;
                            border-right: 1px solid rgba(219,219,219,1);
                            -webkit-transform-origin: 0 0;
                            -moz-transform-origin: 0 0;
                            -ms-transform-origin: 0 0;
                            -o-transform-origin: 0 0;
                            transform-origin: 0 0;
                            -webkit-transform: scale(0.5, 1);
                            -ms-transform: scale(0.5, 1);
                            -o-transform: scale(0.5, 1);
                            transform: scale(0.5, 1);
                        }
                        .works{
                            width: calc(100% - 92px);
                            height: 100%;
                            margin-left: 15px;
                            overflow: hidden;
                            .el-input{
                                .el-input__inner{
                                    border: none !important;
                                }
                            }
                        }
                    }
                    .city_work_container{
                        width: 416px;
                        height: 198px;
                        border-radius:2px;
                        border:1px solid #ececec;
                        margin-top: 8px;
                        justify-content: space-around;
                        .work_group{

                        }
                        .group_title_container{
                            width: 92px;
                            height: 100%;
                            .group_title{
                                width: 100%;
                                height: 33px;
                                line-height: 31px;
                                text-align: center;
                                cursor: pointer;
                                color: #404040;
                                background:rgba(248,248,250,1);;
                            }
                            .active{
                                color: #606060;
                                background-color: #fff;
                            }
                        }
                        .group_container{
                            width: calc(100% - 92px);
                            height: 100%;
                            box-sizing: border-box;
                            -webkit-box-sizing: border-box;
                            -moz-box-sizing: border-box;
                            padding: 17px 26px;
                            .el-scrollbar{
                                .el-scrollbar__wrap{
                                    .el-scrollbar__view{
                                        .city_title{
                                            width:58px;
                                            height:24px;
                                            border-radius:2px;
                                            margin-left: 10px;
                                            margin-top: 10px;
                                            text-align: center;
                                            line-height: 24px;
                                            font-size: 12px;
                                            border:1px solid #ececec;
                                            box-sizing: border-box;
                                            -moz-box-sizing: border-box;
                                            -webkit-box-sizing: border-box;
                                            cursor: pointer;
                                            color: #9c9c9c;
                                        }
                                        .active{
                                            border-color: #FF6644;
                                            color: #FF6644;
                                        }
                                        .city_title:first-child,.city_title:nth-child(2),.city_title:nth-child(3),.city_title:nth-child(4){
                                            margin-top: 0;
                                        }
                                        .city_title:nth-child(4n-3){
                                            margin-left: 0;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .no_border{
                        border-color: transparent;
                    }
                    .submit_btn{
                        width: 100%;
                        height: 50px;
                        margin-top: 18px;
                        background-color: #FF6644;
                        color: #fff;
                        border: none;
                    }
                    .not_submit{
                        width: 100%;
                        height: 46px;
                        margin-top: 18px;
                        background:#CFCFCF;
                        border-radius:3px;
                        color: #fff;
                    }
                    .ignore_btn{
                        width: 100%;
                        height: 46px;
                        color: #9C9C9C;
                        margin-left: 0;
                        background-color: transparent;
                        border: none;
                    }
                }
            }
        }
    }

    .gender-box {
      display: flex;
      justify-content: center;
      margin-top: 54px;
      height: 32px;

      .gender-btn {
        width: 82px;
        height: 32px;
        background: #F9F9F9;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #9C9C9C;
        margin-bottom: 53px;
        cursor: pointer;
        >i {
        color: #9C9C9C;
          font-size: 12px;
        }
      }

      .male-btn {
        border-radius: 16px 0px 0px 16px;
        >i {
          margin-right: 7px;
        }
        &.active {
          background: #4183FF;
          color: #fff;
          >i {
            color: #fff;
          }
        }
      }

      .female-btn {
        border-radius: 0px 16px 16px 0px;
        >i {
          margin-left: 7px;
        }
        &.active {
          background: #FF6644;
          color: #fff;
          >i {
            color: #fff;
          }
        }
      }
    }
</style>